export default "__VITE_ASSET__BbqDaXzP__"